import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { commonConfig } from 'src/environments/common-config';
import { environment } from 'src/environments/environment';
 
const baseURL = environment.endpoint;
 
export interface AppConfig {
  isDriverLastNameRequired: boolean;
  isGroupOperatorLastNameRequired: boolean;
  isParkingAdminLastNameRequired: boolean;
  isManagerLastNameRequired: boolean;
  encryptionKey?: string;
  versions: {
    adminRoles: string;
    driver: string;
    groupOperator: string;
  };
  googleMapsApiKey?: string;
  appUrls: {
    android: string;
    ios: string;
  };
  mapUrls: {
    streetView: string;
    markerClusterImagePath: string;
    googleMapsBase: string;
  };
  truckIcon: string;
  appId: string;
  mockObj?: any;
  [key: string]: any;
}
 
@Injectable({ providedIn: 'root' })
export class ConfigService {
  private config: AppConfig = { ...commonConfig };
 
  constructor(private http: HttpClient) {}
 
  async loadConfig(): Promise<void> {
    try {
      const response = await firstValueFrom(
        this.http.get<{ data: AppConfig }>(`${baseURL}User/GetConfigurations`)
      );
 
      if (response?.data && typeof response.data === 'object') {
        this.config = { ...commonConfig, ...response.data };
      } else {
        console.warn('Config API returned invalid data, using fallback config.');
      }
    } catch (err: any) {
      console.error(
        'Config API failed — using fallback config:',
        err?.message || err
      );
    }
  }
 
  get<T = any>(key: keyof AppConfig): T | null {
    return this.config ? (this.config[key] as T) : null;
  }
 
  getAll(): AppConfig {
    return this.config;
  }
}
 
 